"use client";

export interface MehrfachfilterOption {
  wert: string;
  label: string;
}

const PILLE =
  "py-1 px-2.5 inline-flex items-center gap-x-1.5 text-xs rounded-full border border-layer-line bg-layer text-layer-foreground hover:bg-layer-hover focus:outline-hidden focus-visible:ring-2 focus-visible:ring-primary-focus disabled:opacity-50 disabled:pointer-events-none";
const PILLE_AKTIV =
  "py-1 ps-2.5 pe-1.5 inline-flex items-center gap-x-1 text-xs font-medium rounded-full border border-primary-200 bg-primary-100 text-primary-800 hover:bg-primary-200 focus:outline-hidden focus-visible:ring-2 focus-visible:ring-primary-focus disabled:opacity-50 disabled:pointer-events-none";

/**
 * Mehrfachfilter (Kantine „Allergene & Zusatzstoffe“, Filter „Ohne: …“, Betreiber 18.10.2026, F1; Design-Guide `mehrfachfilter.md`):
 * Pillen mit Umschalter (`aria-pressed`), BELIEBIG VIELE gewählt. Eine gewählte Pille trägt ein Kreuz (Hinweis „Klick nimmt zurück“),
 * der Text bleibt der Träger der Aussage. Kontrolliert: der Aufrufer hält den Zustand; der Baustein speichert, lädt und prüft nichts.
 * Gegenstück zum `Schnellfilter` (genau eine Wahl, mit Zähler).
 */
export function Mehrfachfilter({
  titel,
  vorsatz,
  optionen,
  gewaehlt,
  onUmschalten,
}: {
  /** Name der Gruppe für Hilfstechnik („Allergene ausschließen“). */
  titel: string;
  /** Sichtbares Wort vor den Pillen („Ohne:“). */
  vorsatz?: string;
  optionen: readonly MehrfachfilterOption[];
  gewaehlt: readonly string[];
  onUmschalten: (wert: string) => void;
}) {
  return (
    <>
      {/* Preline: forms/forms-sub-filters-refinement/forms-cat-filter-bars/search-and-filter-toolbar */}
      <div className="flex flex-wrap items-center gap-1.5" role="group" aria-label={titel}>
        {vorsatz && <span className="me-1 text-sm text-muted-foreground-1">{vorsatz}</span>}
        {optionen.map((o) => {
          const an = gewaehlt.includes(o.wert);
          return (
            <button key={o.wert} type="button" className={an ? PILLE_AKTIV : PILLE} aria-pressed={an} onClick={() => onUmschalten(o.wert)}>
              {o.label}
              {an && (
                <svg
                  className="shrink-0 size-3"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d="M18 6 6 18" />
                  <path d="m6 6 12 12" />
                </svg>
              )}
            </button>
          );
        })}
      </div>
    </>
  );
}
